"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _game = require("../selectors/game");

exports.default = function (messageLayer) {
  return function (store) {
    return function (next) {
      return function (action) {
        //TODO: How does this work in the socket world?
        //This is a remote action from another client, just reduce it
        if (action.meta && action.meta.senderPlayerId > -1) {
          return next(action);
        }
        /**
         * Handle remoteRequest
         * Sends an action to the server, which will then dispatch a different,
         * requested action in return
         * For example:
         *  remoteRequest for RunCode will trigger a runCode async action on the server
         */


        if (action.meta && action.meta.remoteRequest === true) {
          messageLayer.emit("remoteRequest", action);
          return;
        } //Send actions to be shared across clients


        if (action.meta && action.meta.shared === true) {
          var sharedAction = _extends({}, action, {
            meta: _extends({}, action.meta, {
              senderPlayerId: (0, _game.selectThisPlayerId)(store.getState())
            })
          });

          messageLayer.emit("shared", sharedAction);
        }

        return next(action);
      };
    };
  };
};